import { Component, OnInit } from "@angular/core";
import { Product } from "src/app/modals/product.model";
import { CartItem } from "src/app/modals/cart-item";
import { ProductService } from "../../shared/services/product.service";
import { CartService } from "../../shared/services/cart.service";
import { NgxSpinnerService } from "ngx-spinner";
import { EnumService } from "../../shared/services/enum.service";
import { Router } from "@angular/router";
import { EcommService } from "src/app/services/ecomm.service";

@Component({
  selector: "app-home-six",
  templateUrl: "./home-six.component.html",
  styleUrls: ["./home-six.component.sass"],
})
export class HomeSixComponent implements OnInit {
  products: Product[] = [];
  banerItemInicio: any;
  shoppingCartItems: any;

  // public slides = [
  //   { title: 'Huge sale', subtitle: 'Up to 70%', image: 'https://novaplaza.pe/img/promociones/banner-bicicletas-intense-devices-3.jpg' },
  //   { title: 'Biggest discount', subtitle: 'Check the promotion', image: 'assets/images/carousel/banner2.jpg' },
  //   { title: 'Biggest sale', subtitle: 'Dont miss it', image: 'assets/images/carousel/banner3.jpg' },
  //   { title: 'Our best products', subtitle: 'Special selection', image: 'assets/images/carousel/banner4.jpg' },
  //   { title: 'Massive sale', subtitle: 'Only for today', image: 'assets/images/carousel/banner5.jpg' }
  // ];
  public slides: any[] = [];
  public discount: any[] = [];
  private loader: boolean = true;
  showMenuCat: boolean = true;
  // discount: any[] = [];
  constructor(
    private productService: ProductService,
    private cartService: CartService,
    private enumService: EnumService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private appHelper: EcommService,
  ) {}

  ngOnInit() {
    // this.appHelper.post("/").subscribe((res:any) => {
    //   console.log(res)
    //  })
    localStorage.removeItem("cart");
    localStorage.removeItem("cartItem");
    localStorage.removeItem("email");
    sessionStorage.removeItem("marca");

    this.spinner.show();
    this.cartService
      .getItems()
      .subscribe(
        (shoppingCartItems) => (this.shoppingCartItems = shoppingCartItems)
      );
    //#region Banners
    this.productService.getBanners().subscribe(
      (baner: any) => {
        // ////console.log(baner.itemsEcCat);
        // //console.log(baner)
        this.banerItemInicio = baner;
        // console.log(baner)
        //#region items
        this.spinner.hide();
        this.productService.getProducts().subscribe(
          (product: Product[]) => {
            this.products.splice(0, this.products.length);
            this.products = product;
          },
          (error: any) => {
            this.spinner.hide();
          }
        );
        //#endregion
      },
      (error: any) => {
        this.spinner.hide();
      }
    );

    //#endregion
  }
  ngDoCheck() {

    let tamaño = window.innerWidth;
    // if (tamaño >= 730) {
    //   this.showMenuCat = true;
    // } else {
    //   this.showMenuCat = false;
    // }

  }
  irAProductos(item) {
    let paramCodigo = item.Codigo.length == 0 ? "0" : item.Codigo;
    if(sessionStorage.getItem("paramFilter") != null){
      let paramNomItem =  {
        param1: "",
        param2: "",
        param3: ""
      }
     sessionStorage.setItem("paramFilter",JSON.stringify(paramNomItem)) 
    }
    sessionStorage.setItem("marca","TODAS")
    if (item.idItem == null) {
      if (item.Marca.length == 0) {
        this.router.navigate(["/home/products", paramCodigo,0, "TODAS", 0,0,1]);
      } else {
        this.router.navigate(["/home/products", paramCodigo, 0,item.Marca, 0,0,1]);
      }
    } else {
      this.router.navigate(["/home/product", item.idItem]);
    }
  }

 }
